// src/components/modalForm/ModalTabs.js
import React, { Children, cloneElement, isValidElement, useId, useLayoutEffect, useRef } from 'react';
import { useModalForm } from './ModalFormContext';

const ModalTabs = ({ children, className = '', ...props }) => {
  const tabsId = useId();
  const { tabPanelId, setActiveTabId } = useModalForm();
  const tabsRef = useRef(null);
  let tabIndex = 0;
  let selectedId = null;
  const prepare = (items) => Children.map(items, (child) => {
    if (!isValidElement(child)) return child;
    if (child.type === 'button') {
      const selected = child.props.className?.split(/\s+/).includes('active');
      const id = `${tabsId}-${tabIndex++}`;
      if (selected) selectedId = id;
      return cloneElement(child, { id, type: 'button', role: 'tab', 'aria-selected': !!selected, 'aria-controls': tabPanelId, tabIndex: selected ? 0 : -1 });
    }
    return child.props.children ? cloneElement(child, { ...(child.type === 'li' ? { role: 'presentation' } : {}), children: prepare(child.props.children) }) : child;
  });
  const content = prepare(children);
  useLayoutEffect(() => { setActiveTabId?.(selectedId); }, [selectedId, setActiveTabId]);
  const handleKeyDown = (event) => {
    const tabs = [...tabsRef.current.querySelectorAll('[role="tab"]')].filter((tab) => !tab.disabled);
    const index = tabs.indexOf(event.target);
    if (index < 0 || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault();
    const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
    tabs[next].focus();
    tabs[next].click();
  };
  return <ul {...props} className={`nav nav-tabs modal-tabs ${className}`.trim()} role="tablist" aria-label="Seções do cadastro" ref={tabsRef} onKeyDown={handleKeyDown}>{content}</ul>;
};

const ModalTabPanel = ({ children, className = '', ...props }) => {
  const { tabPanelId, activeTabId } = useModalForm();
  return <div {...props} className={`tab-content ${className}`.trim()} role="tabpanel" id={tabPanelId} aria-labelledby={activeTabId || undefined}>{children}</div>;
};

ModalTabs.Panel = ModalTabPanel;

export default ModalTabs;
